//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface ICartClient {
    addItemToCart(command: AddItemToCartCommand): Observable<CartModel>;
    getUserCart(): Observable<CartModel>;
    removeItemFromCart(command: RemoveItemFromCartCommand): Observable<CartModel>;
    clearUserCart(command: ClearCartCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class CartClient implements ICartClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    addItemToCart(command: AddItemToCartCommand): Observable<CartModel> {
        let url_ = this.baseUrl + "/api/Cart/AdditemToCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddItemToCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddItemToCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartModel>;
        }));
    }

    protected processAddItemToCart(response: HttpResponseBase): Observable<CartModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CartModel>(null as any);
    }

    getUserCart(): Observable<CartModel> {
        let url_ = this.baseUrl + "/api/Cart/GetUserCart";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartModel>;
        }));
    }

    protected processGetUserCart(response: HttpResponseBase): Observable<CartModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CartModel>(null as any);
    }

    removeItemFromCart(command: RemoveItemFromCartCommand): Observable<CartModel> {
        let url_ = this.baseUrl + "/api/Cart/RemoveItemFromCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveItemFromCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveItemFromCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartModel>;
        }));
    }

    protected processRemoveItemFromCart(response: HttpResponseBase): Observable<CartModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CartModel>(null as any);
    }

    clearUserCart(command: ClearCartCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Cart/ClearUserCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearUserCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearUserCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processClearUserCart(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IOrderClient {
    createOrder(command: CreateOrderCommand): Observable<OrderModel>;
    getOrderHistory(): Observable<OrderModel[]>;
    getOrderById(id: number): Observable<OrderModel>;
}

@Injectable({
    providedIn: 'root'
})
export class OrderClient implements IOrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createOrder(command: CreateOrderCommand): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processCreateOrder(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderModel>(null as any);
    }

    getOrderHistory(): Observable<OrderModel[]> {
        let url_ = this.baseUrl + "/api/Order";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel[]>;
        }));
    }

    protected processGetOrderHistory(response: HttpResponseBase): Observable<OrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderModel[]>(null as any);
    }

    getOrderById(id: number): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Order/GetOrderById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processGetOrderById(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderModel>(null as any);
    }
}

export interface IProductClient {
    getProducts(query: GetProductsQuery): Observable<ProductReturnModel>;
    getProductBySkuCode(query: GetProductBySkuQuery): Observable<SkuResult>;
    uploadFiles(command: UploadProductImagesCommand): Observable<boolean>;
    assignCover(command: AssignCoverImageCommand): Observable<boolean>;
    updateDescription(command: UpdateDescriptionCommand): Observable<SkuResult>;
    productSearch(query: GetProductSearchQuery): Observable<ProductReturnModel>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductClient implements IProductClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getProducts(query: GetProductsQuery): Observable<ProductReturnModel> {
        let url_ = this.baseUrl + "/api/Product/GetProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductReturnModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductReturnModel>;
        }));
    }

    protected processGetProducts(response: HttpResponseBase): Observable<ProductReturnModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductReturnModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductReturnModel>(null as any);
    }

    getProductBySkuCode(query: GetProductBySkuQuery): Observable<SkuResult> {
        let url_ = this.baseUrl + "/api/Product/GetProductBySkuCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductBySkuCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductBySkuCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SkuResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SkuResult>;
        }));
    }

    protected processGetProductBySkuCode(response: HttpResponseBase): Observable<SkuResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SkuResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SkuResult>(null as any);
    }

    uploadFiles(command: UploadProductImagesCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Product/UploadProductImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    updateDescription(command: UpdateDescriptionCommand): Observable<SkuResult> {
        let url_ = this.baseUrl + "/api/Product/UpdateDescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SkuResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SkuResult>;
        }));
    }

    protected processUpdateDescription(response: HttpResponseBase): Observable<SkuResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SkuResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SkuResult>(null as any);
    }

    productSearch(query: GetProductSearchQuery): Observable<ProductReturnModel> {
        let url_ = this.baseUrl + "/api/Product/ProductSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductReturnModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductReturnModel>;
        }));
    }

    protected processProductSearch(response: HttpResponseBase): Observable<ProductReturnModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductReturnModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductReturnModel>(null as any);
    }

    assignCover(command: AssignCoverImageCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Product/AssignCoverImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignCover(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAssignCover(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IRolesClient {
    get(id: RoleEnum, includeUsers: boolean | undefined): Observable<RoleModel>;
    getAll(includeUsers: boolean | undefined): Observable<RoleModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class RolesClient implements IRolesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: RoleEnum, includeUsers: boolean | undefined): Observable<RoleModel> {
        let url_ = this.baseUrl + "/api/Roles/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeUsers === null)
            throw new Error("The parameter 'includeUsers' cannot be null.");
        else if (includeUsers !== undefined)
            url_ += "includeUsers=" + encodeURIComponent("" + includeUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleModel>(null as any);
    }

    getAll(includeUsers: boolean | undefined): Observable<RoleModel[]> {
        let url_ = this.baseUrl + "/api/Roles?";
        if (includeUsers === null)
            throw new Error("The parameter 'includeUsers' cannot be null.");
        else if (includeUsers !== undefined)
            url_ += "includeUsers=" + encodeURIComponent("" + includeUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleModel[]>(null as any);
    }
}

export interface ITenantsClient {
    get(id: string, includeUsers: boolean | undefined): Observable<TenantModel>;
    getAll(includeUsers: boolean | undefined): Observable<TenantModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class TenantsClient implements ITenantsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: string, includeUsers: boolean | undefined): Observable<TenantModel> {
        let url_ = this.baseUrl + "/api/Tenants/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeUsers === null)
            throw new Error("The parameter 'includeUsers' cannot be null.");
        else if (includeUsers !== undefined)
            url_ += "includeUsers=" + encodeURIComponent("" + includeUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantModel>(null as any);
    }

    getAll(includeUsers: boolean | undefined): Observable<TenantModel[]> {
        let url_ = this.baseUrl + "/api/Tenants?";
        if (includeUsers === null)
            throw new Error("The parameter 'includeUsers' cannot be null.");
        else if (includeUsers !== undefined)
            url_ += "includeUsers=" + encodeURIComponent("" + includeUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantModel[]>(null as any);
    }
}

export interface IUsersClient {
    authenticateUser(command: AuthenticateUserCommand): Observable<IssuedTokenModel>;
    authenticateUserUsingEmail(command: AuthenticateUserViaEmailCommand): Observable<IssuedTokenModel>;
    createUser(command: CreateUserCommand): Observable<UserModel>;
    updateUser(command: UpdateUserCommand): Observable<UserModel>;
    getAllUsers(): Observable<UserModel[]>;
    enableUser(id: string): Observable<FileResponse>;
    disableUser(id: string): Observable<FileResponse>;
    getUserById(id: string): Observable<UserModel>;
    searchActiveDirectoryUsers(username: string | null | undefined): Observable<ActiveDirectoryUserModel[]>;
    getRolesByUserId(userId: string): Observable<UserModel>;
    resetPassword(command: ResetPasswordCommand): Observable<ResetPasswordResponse>;
    requestPasswordReset(command: RequestPasswordResetCommand): Observable<RequestPasswordResetResponse>;
    getUserOtpDetails(command: GetPastelCustomerByAccountQuery): Observable<PastelCustomerDetailModel>;
    getCustomerDetails(): Observable<PastelCustomerModel>;
    preRegisterAccount(command: PreRegisterUserCommand): Observable<PreRegisterResultModel>;
    registerExternalUser(command: RegisterExternalUserCommand): Observable<UserModel>;
}

@Injectable({
    providedIn: 'root'
})
export class UsersClient implements IUsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    authenticateUser(command: AuthenticateUserCommand): Observable<IssuedTokenModel> {
        let url_ = this.baseUrl + "/api/Users/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IssuedTokenModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IssuedTokenModel>;
        }));
    }

    protected processAuthenticateUser(response: HttpResponseBase): Observable<IssuedTokenModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IssuedTokenModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IssuedTokenModel>(null as any);
    }

    authenticateUserUsingEmail(command: AuthenticateUserViaEmailCommand): Observable<IssuedTokenModel> {
        let url_ = this.baseUrl + "/api/Users/AuthenticateUsingEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateUserUsingEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateUserUsingEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IssuedTokenModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IssuedTokenModel>;
        }));
    }

    protected processAuthenticateUserUsingEmail(response: HttpResponseBase): Observable<IssuedTokenModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IssuedTokenModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IssuedTokenModel>(null as any);
    }

    createUser(command: CreateUserCommand): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }

    updateUser(command: UpdateUserCommand): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }

    getAllUsers(): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetAllUsers(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel[]>(null as any);
    }

    enableUser(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Users/{id}/Enable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processEnableUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    disableUser(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Users/{id}/Disable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDisableUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getUserById(id: string): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }

    searchActiveDirectoryUsers(username: string | null | undefined): Observable<ActiveDirectoryUserModel[]> {
        let url_ = this.baseUrl + "/api/Users/SearchActiveDirectoryUsers?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchActiveDirectoryUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchActiveDirectoryUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveDirectoryUserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveDirectoryUserModel[]>;
        }));
    }

    protected processSearchActiveDirectoryUsers(response: HttpResponseBase): Observable<ActiveDirectoryUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveDirectoryUserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveDirectoryUserModel[]>(null as any);
    }

    getRolesByUserId(userId: string): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/Users/{userId}/Roles";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolesByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolesByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processGetRolesByUserId(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }

    resetPassword(command: ResetPasswordCommand): Observable<ResetPasswordResponse> {
        let url_ = this.baseUrl + "/api/Users/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordResponse>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordResponse>(null as any);
    }

    requestPasswordReset(command: RequestPasswordResetCommand): Observable<RequestPasswordResetResponse> {
        let url_ = this.baseUrl + "/api/Users/RequestPasswordReset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestPasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestPasswordReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestPasswordResetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestPasswordResetResponse>;
        }));
    }

    protected processRequestPasswordReset(response: HttpResponseBase): Observable<RequestPasswordResetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestPasswordResetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestPasswordResetResponse>(null as any);
    }

    getUserOtpDetails(command: GetPastelCustomerByAccountQuery): Observable<PastelCustomerDetailModel> {
        let url_ = this.baseUrl + "/api/Users/GetUserOtpDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserOtpDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserOtpDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PastelCustomerDetailModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PastelCustomerDetailModel>;
        }));
    }

    protected processGetUserOtpDetails(response: HttpResponseBase): Observable<PastelCustomerDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PastelCustomerDetailModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PastelCustomerDetailModel>(null as any);
    }

    getCustomerDetails(): Observable<PastelCustomerModel> {
        let url_ = this.baseUrl + "/api/Users/GetCustomerDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PastelCustomerModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PastelCustomerModel>;
        }));
    }

    protected processGetCustomerDetails(response: HttpResponseBase): Observable<PastelCustomerModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PastelCustomerModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PastelCustomerModel>(null as any);
    }

    preRegisterAccount(command: PreRegisterUserCommand): Observable<PreRegisterResultModel> {
        let url_ = this.baseUrl + "/api/Users/PreRegisterUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreRegisterAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreRegisterAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreRegisterResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreRegisterResultModel>;
        }));
    }

    protected processPreRegisterAccount(response: HttpResponseBase): Observable<PreRegisterResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreRegisterResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreRegisterResultModel>(null as any);
    }

    registerExternalUser(command: RegisterExternalUserCommand): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/Users/RegisterExternalUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterExternalUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterExternalUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processRegisterExternalUser(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }
}

export interface IWishlistClient {
    addItemToWishlist(command: AddItemToWishlistCommand): Observable<WishlistModel>;
    getUserWishlist(): Observable<WishlistModel>;
    removeItemFromWishlist(command: RemoveItemFromWishlistCommand): Observable<WishlistModel>;
    clearUserWishlist(command: ClearWishlistCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class WishlistClient implements IWishlistClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    addItemToWishlist(command: AddItemToWishlistCommand): Observable<WishlistModel> {
        let url_ = this.baseUrl + "/api/Wishlist/AdditemToWishlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddItemToWishlist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddItemToWishlist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WishlistModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WishlistModel>;
        }));
    }

    protected processAddItemToWishlist(response: HttpResponseBase): Observable<WishlistModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WishlistModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WishlistModel>(null as any);
    }

    getUserWishlist(): Observable<WishlistModel> {
        let url_ = this.baseUrl + "/api/Wishlist/GetUserWishlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserWishlist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWishlist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WishlistModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WishlistModel>;
        }));
    }

    protected processGetUserWishlist(response: HttpResponseBase): Observable<WishlistModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WishlistModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WishlistModel>(null as any);
    }

    removeItemFromWishlist(command: RemoveItemFromWishlistCommand): Observable<WishlistModel> {
        let url_ = this.baseUrl + "/api/Wishlist/RemoveItemFromWishlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveItemFromWishlist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveItemFromWishlist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WishlistModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WishlistModel>;
        }));
    }

    protected processRemoveItemFromWishlist(response: HttpResponseBase): Observable<WishlistModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WishlistModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WishlistModel>(null as any);
    }

    clearUserWishlist(command: ClearWishlistCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Wishlist/ClearUserWishlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearUserWishlist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearUserWishlist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processClearUserWishlist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export class CartModel implements ICartModel {
    id?: number;
    userId?: string;
    orderReference?: string | undefined;
    createdDate?: Date;
    cartItems?: CartItemModel[] | undefined;
    totalPriceExcl?: number;
    totalPriceIncl?: number;
    discount?: number;
    numberOfItems?: number;

    constructor(data?: ICartModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.orderReference = _data["orderReference"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["cartItems"])) {
                this.cartItems = [] as any;
                for (let item of _data["cartItems"])
                    this.cartItems!.push(CartItemModel.fromJS(item));
            }
            this.totalPriceExcl = _data["totalPriceExcl"];
            this.totalPriceIncl = _data["totalPriceIncl"];
            this.discount = _data["discount"];
            this.numberOfItems = _data["numberOfItems"];
        }
    }

    static fromJS(data: any): CartModel {
        data = typeof data === 'object' ? data : {};
        let result = new CartModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["orderReference"] = this.orderReference;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        if (Array.isArray(this.cartItems)) {
            data["cartItems"] = [];
            for (let item of this.cartItems)
                data["cartItems"].push(item.toJSON());
        }
        data["totalPriceExcl"] = this.totalPriceExcl;
        data["totalPriceIncl"] = this.totalPriceIncl;
        data["discount"] = this.discount;
        data["numberOfItems"] = this.numberOfItems;
        return data;
    }
}

export interface ICartModel {
    id?: number;
    userId?: string;
    orderReference?: string | undefined;
    createdDate?: Date;
    cartItems?: CartItemModel[] | undefined;
    totalPriceExcl?: number;
    totalPriceIncl?: number;
    discount?: number;
    numberOfItems?: number;
}

export class CartItemModel implements ICartItemModel {
    id?: number;
    cartId?: number;
    productId?: string | undefined;
    quantity?: number;
    dealReference?: string | undefined;
    productDescription?: string | undefined;
    listPriceIncl?: number;
    listPriceExcl?: number;
    unitPriceExcl?: number;
    totalPriceExcl?: number;
    totalPriceIncl?: number;
    category?: string | undefined;
    subCategory?: string | undefined;
    brand?: string | undefined;
    assignedDiscount?: number;
    dealDescription?: string | undefined;
    stockOnHand?: number | undefined;
    packSize?: string | undefined;
    capacity?: string | undefined;
    discountPercentage?: number | undefined;
    discountPriceExcl?: number | undefined;
    discountPriceIncl?: number | undefined;
    minOrderQuantityDiscount?: number | undefined;
    isNewProduct?: boolean | undefined;
    rtCategory?: string | undefined;
    imageUrl?: string | undefined;
    stockingWarehouseCode?: string | undefined;

    constructor(data?: ICartItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cartId = _data["cartId"];
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
            this.dealReference = _data["dealReference"];
            this.productDescription = _data["productDescription"];
            this.listPriceIncl = _data["listPriceIncl"];
            this.listPriceExcl = _data["listPriceExcl"];
            this.unitPriceExcl = _data["unitPriceExcl"];
            this.totalPriceExcl = _data["totalPriceExcl"];
            this.totalPriceIncl = _data["totalPriceIncl"];
            this.category = _data["category"];
            this.subCategory = _data["subCategory"];
            this.brand = _data["brand"];
            this.assignedDiscount = _data["assignedDiscount"];
            this.dealDescription = _data["dealDescription"];
            this.stockOnHand = _data["stockOnHand"];
            this.packSize = _data["packSize"];
            this.capacity = _data["capacity"];
            this.discountPercentage = _data["discountPercentage"];
            this.discountPriceExcl = _data["discountPriceExcl"];
            this.discountPriceIncl = _data["discountPriceIncl"];
            this.minOrderQuantityDiscount = _data["minOrderQuantityDiscount"];
            this.isNewProduct = _data["isNewProduct"];
            this.rtCategory = _data["rtCategory"];
            this.imageUrl = _data["imageUrl"];
            this.stockingWarehouseCode = _data["stockingWarehouseCode"];
        }
    }

    static fromJS(data: any): CartItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new CartItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cartId"] = this.cartId;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["dealReference"] = this.dealReference;
        data["productDescription"] = this.productDescription;
        data["listPriceIncl"] = this.listPriceIncl;
        data["listPriceExcl"] = this.listPriceExcl;
        data["unitPriceExcl"] = this.unitPriceExcl;
        data["totalPriceExcl"] = this.totalPriceExcl;
        data["totalPriceIncl"] = this.totalPriceIncl;
        data["category"] = this.category;
        data["subCategory"] = this.subCategory;
        data["brand"] = this.brand;
        data["assignedDiscount"] = this.assignedDiscount;
        data["dealDescription"] = this.dealDescription;
        data["stockOnHand"] = this.stockOnHand;
        data["packSize"] = this.packSize;
        data["capacity"] = this.capacity;
        data["discountPercentage"] = this.discountPercentage;
        data["discountPriceExcl"] = this.discountPriceExcl;
        data["discountPriceIncl"] = this.discountPriceIncl;
        data["minOrderQuantityDiscount"] = this.minOrderQuantityDiscount;
        data["isNewProduct"] = this.isNewProduct;
        data["rtCategory"] = this.rtCategory;
        data["imageUrl"] = this.imageUrl;
        data["stockingWarehouseCode"] = this.stockingWarehouseCode;
        return data;
    }
}

export interface ICartItemModel {
    id?: number;
    cartId?: number;
    productId?: string | undefined;
    quantity?: number;
    dealReference?: string | undefined;
    productDescription?: string | undefined;
    listPriceIncl?: number;
    listPriceExcl?: number;
    unitPriceExcl?: number;
    totalPriceExcl?: number;
    totalPriceIncl?: number;
    category?: string | undefined;
    subCategory?: string | undefined;
    brand?: string | undefined;
    assignedDiscount?: number;
    dealDescription?: string | undefined;
    stockOnHand?: number | undefined;
    packSize?: string | undefined;
    capacity?: string | undefined;
    discountPercentage?: number | undefined;
    discountPriceExcl?: number | undefined;
    discountPriceIncl?: number | undefined;
    minOrderQuantityDiscount?: number | undefined;
    isNewProduct?: boolean | undefined;
    rtCategory?: string | undefined;
    imageUrl?: string | undefined;
    stockingWarehouseCode?: string | undefined;
}

export class AddItemToCartCommand implements IAddItemToCartCommand {
    skuCode?: string | undefined;
    quantity?: number;
    dealReference?: string | undefined;

    constructor(data?: IAddItemToCartCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuCode = _data["skuCode"];
            this.quantity = _data["quantity"];
            this.dealReference = _data["dealReference"];
        }
    }

    static fromJS(data: any): AddItemToCartCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddItemToCartCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuCode"] = this.skuCode;
        data["quantity"] = this.quantity;
        data["dealReference"] = this.dealReference;
        return data;
    }
}

export interface IAddItemToCartCommand {
    skuCode?: string | undefined;
    quantity?: number;
    dealReference?: string | undefined;
}

export class RemoveItemFromCartCommand implements IRemoveItemFromCartCommand {
    skuCode?: string | undefined;
    remove?: boolean;
    quantity?: number;

    constructor(data?: IRemoveItemFromCartCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuCode = _data["skuCode"];
            this.remove = _data["remove"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): RemoveItemFromCartCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveItemFromCartCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuCode"] = this.skuCode;
        data["remove"] = this.remove;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IRemoveItemFromCartCommand {
    skuCode?: string | undefined;
    remove?: boolean;
    quantity?: number;
}

export class ClearCartCommand implements IClearCartCommand {

    constructor(data?: IClearCartCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ClearCartCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClearCartCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IClearCartCommand {
}

export class OrderModel implements IOrderModel {
    id?: number;
    accountName?: string | undefined;
    vatNumber?: string | undefined;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    address4?: string | undefined;
    address5?: string | undefined;
    address6?: string | undefined;
    homeDelivery?: string | undefined;
    orderId?: string | undefined;
    accountId?: string | undefined;
    suppliedId?: string | undefined;
    userId?: string | undefined;
    orderReference?: string | undefined;
    createdDate?: Date;
    orderType?: string | undefined;
    shipmentMethod?: string | undefined;
    orderLines?: OrderLineModel[] | undefined;
    discount?: number;
    cellaPaymentId?: string | undefined;
    payfastPaymentId?: string | undefined;
    cellaAccountId?: string | undefined;
    applyLiqourCheck?: boolean;
    totalPriceExcl?: number;
    totalPriceIncl?: number;
    orderSource?: string | undefined;
    liquor_check?: number;
    creditcheck_override?: string | undefined;
    repCode?: string | undefined;
    currentPastelStatus?: string | undefined;
    lastPastelStatusUpdate?: Date | undefined;
    createdBy?: string | undefined;
    vendorNumber?: string | undefined;
    brand?: string | undefined;

    constructor(data?: IOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountName = _data["accountName"];
            this.vatNumber = _data["vatNumber"];
            this.email = _data["email"];
            this.mobileNumber = _data["mobileNumber"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.address4 = _data["address4"];
            this.address5 = _data["address5"];
            this.address6 = _data["address6"];
            this.homeDelivery = _data["homeDelivery"];
            this.orderId = _data["orderId"];
            this.accountId = _data["accountId"];
            this.suppliedId = _data["suppliedId"];
            this.userId = _data["userId"];
            this.orderReference = _data["orderReference"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.orderType = _data["orderType"];
            this.shipmentMethod = _data["shipmentMethod"];
            if (Array.isArray(_data["orderLines"])) {
                this.orderLines = [] as any;
                for (let item of _data["orderLines"])
                    this.orderLines!.push(OrderLineModel.fromJS(item));
            }
            this.discount = _data["discount"];
            this.cellaPaymentId = _data["cellaPaymentId"];
            this.payfastPaymentId = _data["payfastPaymentId"];
            this.cellaAccountId = _data["cellaAccountId"];
            this.applyLiqourCheck = _data["applyLiqourCheck"];
            this.totalPriceExcl = _data["totalPriceExcl"];
            this.totalPriceIncl = _data["totalPriceIncl"];
            this.orderSource = _data["orderSource"];
            this.liquor_check = _data["liquor_check"];
            this.creditcheck_override = _data["creditcheck_override"];
            this.repCode = _data["repCode"];
            this.currentPastelStatus = _data["currentPastelStatus"];
            this.lastPastelStatusUpdate = _data["lastPastelStatusUpdate"] ? new Date(_data["lastPastelStatusUpdate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.vendorNumber = _data["vendorNumber"];
            this.brand = _data["brand"];
        }
    }

    static fromJS(data: any): OrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountName"] = this.accountName;
        data["vatNumber"] = this.vatNumber;
        data["email"] = this.email;
        data["mobileNumber"] = this.mobileNumber;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["address4"] = this.address4;
        data["address5"] = this.address5;
        data["address6"] = this.address6;
        data["homeDelivery"] = this.homeDelivery;
        data["orderId"] = this.orderId;
        data["accountId"] = this.accountId;
        data["suppliedId"] = this.suppliedId;
        data["userId"] = this.userId;
        data["orderReference"] = this.orderReference;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["orderType"] = this.orderType;
        data["shipmentMethod"] = this.shipmentMethod;
        if (Array.isArray(this.orderLines)) {
            data["orderLines"] = [];
            for (let item of this.orderLines)
                data["orderLines"].push(item.toJSON());
        }
        data["discount"] = this.discount;
        data["cellaPaymentId"] = this.cellaPaymentId;
        data["payfastPaymentId"] = this.payfastPaymentId;
        data["cellaAccountId"] = this.cellaAccountId;
        data["applyLiqourCheck"] = this.applyLiqourCheck;
        data["totalPriceExcl"] = this.totalPriceExcl;
        data["totalPriceIncl"] = this.totalPriceIncl;
        data["orderSource"] = this.orderSource;
        data["liquor_check"] = this.liquor_check;
        data["creditcheck_override"] = this.creditcheck_override;
        data["repCode"] = this.repCode;
        data["currentPastelStatus"] = this.currentPastelStatus;
        data["lastPastelStatusUpdate"] = this.lastPastelStatusUpdate ? this.lastPastelStatusUpdate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["vendorNumber"] = this.vendorNumber;
        data["brand"] = this.brand;
        return data;
    }
}

export interface IOrderModel {
    id?: number;
    accountName?: string | undefined;
    vatNumber?: string | undefined;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    address4?: string | undefined;
    address5?: string | undefined;
    address6?: string | undefined;
    homeDelivery?: string | undefined;
    orderId?: string | undefined;
    accountId?: string | undefined;
    suppliedId?: string | undefined;
    userId?: string | undefined;
    orderReference?: string | undefined;
    createdDate?: Date;
    orderType?: string | undefined;
    shipmentMethod?: string | undefined;
    orderLines?: OrderLineModel[] | undefined;
    discount?: number;
    cellaPaymentId?: string | undefined;
    payfastPaymentId?: string | undefined;
    cellaAccountId?: string | undefined;
    applyLiqourCheck?: boolean;
    totalPriceExcl?: number;
    totalPriceIncl?: number;
    orderSource?: string | undefined;
    liquor_check?: number;
    creditcheck_override?: string | undefined;
    repCode?: string | undefined;
    currentPastelStatus?: string | undefined;
    lastPastelStatusUpdate?: Date | undefined;
    createdBy?: string | undefined;
    vendorNumber?: string | undefined;
    brand?: string | undefined;
}

export class OrderLineModel implements IOrderLineModel {
    productId?: string | undefined;
    productDescription?: string | undefined;
    quantity?: number;
    listPriceExcl?: number;
    unitPriceExcl?: number;
    totalPriceExcl?: number;
    totalPriceIncl?: number;
    warehouseCode?: string | undefined;
    dealReference?: string | undefined;
    category?: string | undefined;
    assignedDiscount?: number | undefined;
    priceManipulated?: boolean | undefined;
    lockedWarehouse?: boolean | undefined;
    dealPercent?: number | undefined;
    discountPriceIncl?: number | undefined;
    discountPriceExcl?: number | undefined;
    tradePercent?: number | undefined;
    dealDescription?: string | undefined;
    priceManipulationReason?: string | undefined;
    pastelSalesOrderNumber?: string | undefined;
    pastelInvoiceNumber?: string | undefined;
    rtCategory?: string | undefined;

    constructor(data?: IOrderLineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productDescription = _data["productDescription"];
            this.quantity = _data["quantity"];
            this.listPriceExcl = _data["listPriceExcl"];
            this.unitPriceExcl = _data["unitPriceExcl"];
            this.totalPriceExcl = _data["totalPriceExcl"];
            this.totalPriceIncl = _data["totalPriceIncl"];
            this.warehouseCode = _data["warehouseCode"];
            this.dealReference = _data["dealReference"];
            this.category = _data["category"];
            this.assignedDiscount = _data["assignedDiscount"];
            this.priceManipulated = _data["priceManipulated"];
            this.lockedWarehouse = _data["lockedWarehouse"];
            this.dealPercent = _data["dealPercent"];
            this.discountPriceIncl = _data["discountPriceIncl"];
            this.discountPriceExcl = _data["discountPriceExcl"];
            this.tradePercent = _data["tradePercent"];
            this.dealDescription = _data["dealDescription"];
            this.priceManipulationReason = _data["priceManipulationReason"];
            this.pastelSalesOrderNumber = _data["pastelSalesOrderNumber"];
            this.pastelInvoiceNumber = _data["pastelInvoiceNumber"];
            this.rtCategory = _data["rtCategory"];
        }
    }

    static fromJS(data: any): OrderLineModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productDescription"] = this.productDescription;
        data["quantity"] = this.quantity;
        data["listPriceExcl"] = this.listPriceExcl;
        data["unitPriceExcl"] = this.unitPriceExcl;
        data["totalPriceExcl"] = this.totalPriceExcl;
        data["totalPriceIncl"] = this.totalPriceIncl;
        data["warehouseCode"] = this.warehouseCode;
        data["dealReference"] = this.dealReference;
        data["category"] = this.category;
        data["assignedDiscount"] = this.assignedDiscount;
        data["priceManipulated"] = this.priceManipulated;
        data["lockedWarehouse"] = this.lockedWarehouse;
        data["dealPercent"] = this.dealPercent;
        data["discountPriceIncl"] = this.discountPriceIncl;
        data["discountPriceExcl"] = this.discountPriceExcl;
        data["tradePercent"] = this.tradePercent;
        data["dealDescription"] = this.dealDescription;
        data["priceManipulationReason"] = this.priceManipulationReason;
        data["pastelSalesOrderNumber"] = this.pastelSalesOrderNumber;
        data["pastelInvoiceNumber"] = this.pastelInvoiceNumber;
        data["rtCategory"] = this.rtCategory;
        return data;
    }
}

export interface IOrderLineModel {
    productId?: string | undefined;
    productDescription?: string | undefined;
    quantity?: number;
    listPriceExcl?: number;
    unitPriceExcl?: number;
    totalPriceExcl?: number;
    totalPriceIncl?: number;
    warehouseCode?: string | undefined;
    dealReference?: string | undefined;
    category?: string | undefined;
    assignedDiscount?: number | undefined;
    priceManipulated?: boolean | undefined;
    lockedWarehouse?: boolean | undefined;
    dealPercent?: number | undefined;
    discountPriceIncl?: number | undefined;
    discountPriceExcl?: number | undefined;
    tradePercent?: number | undefined;
    dealDescription?: string | undefined;
    priceManipulationReason?: string | undefined;
    pastelSalesOrderNumber?: string | undefined;
    pastelInvoiceNumber?: string | undefined;
    rtCategory?: string | undefined;
}

export class CreateOrderCommand implements ICreateOrderCommand {
    order?: CreateOrderModel | undefined;

    constructor(data?: ICreateOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? CreateOrderModel.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrderCommand {
    order?: CreateOrderModel | undefined;
}

export class CreateOrderModel implements ICreateOrderModel {
    orderReference?: string | undefined;
    createdDate?: Date;
    orderLines?: OrderLineModel[] | undefined;
    discount?: number;
    applyLiqourCheck?: boolean;
    totalPriceExcl?: number;
    totalPriceIncl?: number;

    constructor(data?: ICreateOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderReference = _data["orderReference"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["orderLines"])) {
                this.orderLines = [] as any;
                for (let item of _data["orderLines"])
                    this.orderLines!.push(OrderLineModel.fromJS(item));
            }
            this.discount = _data["discount"];
            this.applyLiqourCheck = _data["applyLiqourCheck"];
            this.totalPriceExcl = _data["totalPriceExcl"];
            this.totalPriceIncl = _data["totalPriceIncl"];
        }
    }

    static fromJS(data: any): CreateOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderReference"] = this.orderReference;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        if (Array.isArray(this.orderLines)) {
            data["orderLines"] = [];
            for (let item of this.orderLines)
                data["orderLines"].push(item.toJSON());
        }
        data["discount"] = this.discount;
        data["applyLiqourCheck"] = this.applyLiqourCheck;
        data["totalPriceExcl"] = this.totalPriceExcl;
        data["totalPriceIncl"] = this.totalPriceIncl;
        return data;
    }
}

export interface ICreateOrderModel {
    orderReference?: string | undefined;
    createdDate?: Date;
    orderLines?: OrderLineModel[] | undefined;
    discount?: number;
    applyLiqourCheck?: boolean;
    totalPriceExcl?: number;
    totalPriceIncl?: number;
}

export class ProductReturnModel implements IProductReturnModel {
    total?: number;
    resultsPerPage?: number;
    resultCount?: number;
    pages?: number;
    currentPage?: number;
    sortOrder?: number;
    sortBy?: string | undefined;
    brandFilter?: string | undefined;
    searchFilter?: string | undefined;
    skuResults?: SkuResult[] | undefined;
    categoryResults?: CategoryResult[] | undefined;
    brandResults?: BrandResult[] | undefined;

    constructor(data?: IProductReturnModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.resultsPerPage = _data["resultsPerPage"];
            this.resultCount = _data["resultCount"];
            this.pages = _data["pages"];
            this.currentPage = _data["currentPage"];
            this.sortOrder = _data["sortOrder"];
            this.sortBy = _data["sortBy"];
            this.brandFilter = _data["brandFilter"];
            this.searchFilter = _data["searchFilter"];
            if (Array.isArray(_data["skuResults"])) {
                this.skuResults = [] as any;
                for (let item of _data["skuResults"])
                    this.skuResults!.push(SkuResult.fromJS(item));
            }
            if (Array.isArray(_data["categoryResults"])) {
                this.categoryResults = [] as any;
                for (let item of _data["categoryResults"])
                    this.categoryResults!.push(CategoryResult.fromJS(item));
            }
            if (Array.isArray(_data["brandResults"])) {
                this.brandResults = [] as any;
                for (let item of _data["brandResults"])
                    this.brandResults!.push(BrandResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductReturnModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductReturnModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["resultsPerPage"] = this.resultsPerPage;
        data["resultCount"] = this.resultCount;
        data["pages"] = this.pages;
        data["currentPage"] = this.currentPage;
        data["sortOrder"] = this.sortOrder;
        data["sortBy"] = this.sortBy;
        data["brandFilter"] = this.brandFilter;
        data["searchFilter"] = this.searchFilter;
        if (Array.isArray(this.skuResults)) {
            data["skuResults"] = [];
            for (let item of this.skuResults)
                data["skuResults"].push(item.toJSON());
        }
        if (Array.isArray(this.categoryResults)) {
            data["categoryResults"] = [];
            for (let item of this.categoryResults)
                data["categoryResults"].push(item.toJSON());
        }
        if (Array.isArray(this.brandResults)) {
            data["brandResults"] = [];
            for (let item of this.brandResults)
                data["brandResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductReturnModel {
    total?: number;
    resultsPerPage?: number;
    resultCount?: number;
    pages?: number;
    currentPage?: number;
    sortOrder?: number;
    sortBy?: string | undefined;
    brandFilter?: string | undefined;
    searchFilter?: string | undefined;
    skuResults?: SkuResult[] | undefined;
    categoryResults?: CategoryResult[] | undefined;
    brandResults?: BrandResult[] | undefined;
}

export class SkuResult implements ISkuResult {
    skuCode?: string | undefined;
    skuCategory?: string | undefined;
    skuSubCategory?: string | undefined;
    skuSubCategory2?: string | undefined;
    skuSubCategory3?: string | undefined;
    skuBrand?: string | undefined;
    skuDescription?: string | undefined;
    stockOnHand?: number;
    listPriceIncl?: number;
    listPriceExcl?: number;
    isNewProduct?: boolean;
    packSize?: string | undefined;
    capacity?: string | undefined;
    discountPercentage?: number;
    discountPrice?: number;
    discountPriceExcl?: number;
    discountPriceIncl?: number;
    minOrderQuantityDiscount?: number;
    dealReference?: string | undefined;
    isLiquor?: boolean;
    rtCategory?: string | undefined;
    imageUrl?: string | undefined;
    stockingWarehouseCode?: string | undefined;
    vatRateCharged?: number | undefined;
    extendedData?: ProductExtendedDetailsModel | undefined;

    constructor(data?: ISkuResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuCode = _data["skuCode"];
            this.skuCategory = _data["skuCategory"];
            this.skuSubCategory = _data["skuSubCategory"];
            this.skuSubCategory2 = _data["skuSubCategory2"];
            this.skuSubCategory3 = _data["skuSubCategory3"];
            this.skuBrand = _data["skuBrand"];
            this.skuDescription = _data["skuDescription"];
            this.stockOnHand = _data["stockOnHand"];
            this.listPriceIncl = _data["listPriceIncl"];
            this.listPriceExcl = _data["listPriceExcl"];
            this.isNewProduct = _data["isNewProduct"];
            this.packSize = _data["packSize"];
            this.capacity = _data["capacity"];
            this.discountPercentage = _data["discountPercentage"];
            this.discountPrice = _data["discountPrice"];
            this.discountPriceExcl = _data["discountPriceExcl"];
            this.discountPriceIncl = _data["discountPriceIncl"];
            this.minOrderQuantityDiscount = _data["minOrderQuantityDiscount"];
            this.dealReference = _data["dealReference"];
            this.isLiquor = _data["isLiquor"];
            this.rtCategory = _data["rtCategory"];
            this.imageUrl = _data["imageUrl"];
            this.stockingWarehouseCode = _data["stockingWarehouseCode"];
            this.vatRateCharged = _data["vatRateCharged"];
            this.extendedData = _data["extendedData"] ? ProductExtendedDetailsModel.fromJS(_data["extendedData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SkuResult {
        data = typeof data === 'object' ? data : {};
        let result = new SkuResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuCode"] = this.skuCode;
        data["skuCategory"] = this.skuCategory;
        data["skuSubCategory"] = this.skuSubCategory;
        data["skuSubCategory2"] = this.skuSubCategory2;
        data["skuSubCategory3"] = this.skuSubCategory3;
        data["skuBrand"] = this.skuBrand;
        data["skuDescription"] = this.skuDescription;
        data["stockOnHand"] = this.stockOnHand;
        data["listPriceIncl"] = this.listPriceIncl;
        data["listPriceExcl"] = this.listPriceExcl;
        data["isNewProduct"] = this.isNewProduct;
        data["packSize"] = this.packSize;
        data["capacity"] = this.capacity;
        data["discountPercentage"] = this.discountPercentage;
        data["discountPrice"] = this.discountPrice;
        data["discountPriceExcl"] = this.discountPriceExcl;
        data["discountPriceIncl"] = this.discountPriceIncl;
        data["minOrderQuantityDiscount"] = this.minOrderQuantityDiscount;
        data["dealReference"] = this.dealReference;
        data["isLiquor"] = this.isLiquor;
        data["rtCategory"] = this.rtCategory;
        data["imageUrl"] = this.imageUrl;
        data["stockingWarehouseCode"] = this.stockingWarehouseCode;
        data["vatRateCharged"] = this.vatRateCharged;
        data["extendedData"] = this.extendedData ? this.extendedData.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISkuResult {
    skuCode?: string | undefined;
    skuCategory?: string | undefined;
    skuSubCategory?: string | undefined;
    skuSubCategory2?: string | undefined;
    skuSubCategory3?: string | undefined;
    skuBrand?: string | undefined;
    skuDescription?: string | undefined;
    stockOnHand?: number;
    listPriceIncl?: number;
    listPriceExcl?: number;
    isNewProduct?: boolean;
    packSize?: string | undefined;
    capacity?: string | undefined;
    discountPercentage?: number;
    discountPrice?: number;
    discountPriceExcl?: number;
    discountPriceIncl?: number;
    minOrderQuantityDiscount?: number;
    dealReference?: string | undefined;
    isLiquor?: boolean;
    rtCategory?: string | undefined;
    imageUrl?: string | undefined;
    stockingWarehouseCode?: string | undefined;
    vatRateCharged?: number | undefined;
    extendedData?: ProductExtendedDetailsModel | undefined;
}

export class ProductExtendedDetailsModel implements IProductExtendedDetailsModel {
    id?: number;
    skuCode?: string | undefined;
    primaryGTIN?: string | undefined;
    manufacturerProductCode?: string | undefined;
    packConfiguration?: string | undefined;
    productWidthMM?: string | undefined;
    productDepthMM?: string | undefined;
    productHeightMM?: string | undefined;
    productGrossWeightG?: string | undefined;
    brand?: string | undefined;
    subBrand?: string | undefined;
    productName?: string | undefined;
    productType?: string | undefined;
    productVariant?: string | undefined;
    needState?: string | undefined;
    modelNumber?: string | undefined;
    packQuantity?: string | undefined;
    unitOfSize?: string | undefined;
    unitOfMeasure?: string | undefined;
    productMaterials?: string | undefined;
    colourName?: string | undefined;
    siloMarketingDescription?: string | undefined;
    siloKeywords?: string | undefined;
    siloShortDescription?: string | undefined;
    siloFeaturesBenefits?: string | undefined;
    videoLink?: string | undefined;
    packagingMaterial?: string | undefined;
    recyclable?: string | undefined;
    whatsInTheBox?: string | undefined;
    countryOfOrigin?: string | undefined;
    usageInstructions?: string | undefined;
    storageInstructions?: string | undefined;
    shelfLifeSellBy?: string | undefined;
    serviceGuaranteeWarranty?: string | undefined;
    generalWarnings?: string | undefined;
    ingredients?: string | undefined;
    allergenWarnings?: string | undefined;
    commonAllergens?: string | undefined;
    organic?: string | undefined;
    vegan?: string | undefined;
    vegetarian?: string | undefined;
    glutenFree?: string | undefined;
    freeRange?: string | undefined;
    otherClaims?: string | undefined;
    halaal?: string | undefined;
    kosher?: string | undefined;
    otherEndorsements?: string | undefined;
    alcoholPercentage?: string | undefined;
    servingSize?: string | undefined;
    servingSizeUOM?: string | undefined;
    energy100gKJ?: string | undefined;
    servingEnergykJ?: string | undefined;
    carbohydrate100gG?: string | undefined;
    servingCarbohydrateG?: string | undefined;
    totalSugar100gG?: string | undefined;
    servingOfWhichTotalSugarG?: string | undefined;
    totalFat100gG?: string | undefined;
    servingTotalFatG?: string | undefined;
    saturatedFat100gG?: string | undefined;
    servingSaturatedFatG?: string | undefined;
    monounsaturatedFat100gG?: string | undefined;
    servingMonounsaturatedFatG?: string | undefined;
    polyunsaturatedFat100gG?: string | undefined;
    servingPolyunsaturatedFatG?: string | undefined;
    transFat100gG?: string | undefined;
    servingTransFatG?: string | undefined;
    protein100gG?: string | undefined;
    servingProteinG?: string | undefined;
    dietaryFibre100g?: string | undefined;
    servingDietaryFibre?: string | undefined;
    cholestrol100gMG?: string | undefined;
    servingCholestrolMG?: string | undefined;
    omega3FattyAcids100gMG?: string | undefined;
    servingOmega3FattyAcidsMG?: string | undefined;
    totalSodium100gMG?: string | undefined;
    servingTotalSodiumMG?: string | undefined;

    constructor(data?: IProductExtendedDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuCode = _data["skuCode"];
            this.primaryGTIN = _data["primaryGTIN"];
            this.manufacturerProductCode = _data["manufacturerProductCode"];
            this.packConfiguration = _data["packConfiguration"];
            this.productWidthMM = _data["productWidthMM"];
            this.productDepthMM = _data["productDepthMM"];
            this.productHeightMM = _data["productHeightMM"];
            this.productGrossWeightG = _data["productGrossWeightG"];
            this.brand = _data["brand"];
            this.subBrand = _data["subBrand"];
            this.productName = _data["productName"];
            this.productType = _data["productType"];
            this.productVariant = _data["productVariant"];
            this.needState = _data["needState"];
            this.modelNumber = _data["modelNumber"];
            this.packQuantity = _data["packQuantity"];
            this.unitOfSize = _data["unitOfSize"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.productMaterials = _data["productMaterials"];
            this.colourName = _data["colourName"];
            this.siloMarketingDescription = _data["siloMarketingDescription"];
            this.siloKeywords = _data["siloKeywords"];
            this.siloShortDescription = _data["siloShortDescription"];
            this.siloFeaturesBenefits = _data["siloFeaturesBenefits"];
            this.videoLink = _data["videoLink"];
            this.packagingMaterial = _data["packagingMaterial"];
            this.recyclable = _data["recyclable"];
            this.whatsInTheBox = _data["whatsInTheBox"];
            this.countryOfOrigin = _data["countryOfOrigin"];
            this.usageInstructions = _data["usageInstructions"];
            this.storageInstructions = _data["storageInstructions"];
            this.shelfLifeSellBy = _data["shelfLifeSellBy"];
            this.serviceGuaranteeWarranty = _data["serviceGuaranteeWarranty"];
            this.generalWarnings = _data["generalWarnings"];
            this.ingredients = _data["ingredients"];
            this.allergenWarnings = _data["allergenWarnings"];
            this.commonAllergens = _data["commonAllergens"];
            this.organic = _data["organic"];
            this.vegan = _data["vegan"];
            this.vegetarian = _data["vegetarian"];
            this.glutenFree = _data["glutenFree"];
            this.freeRange = _data["freeRange"];
            this.otherClaims = _data["otherClaims"];
            this.halaal = _data["halaal"];
            this.kosher = _data["kosher"];
            this.otherEndorsements = _data["otherEndorsements"];
            this.alcoholPercentage = _data["alcoholPercentage"];
            this.servingSize = _data["servingSize"];
            this.servingSizeUOM = _data["servingSizeUOM"];
            this.energy100gKJ = _data["energy100gKJ"];
            this.servingEnergykJ = _data["servingEnergykJ"];
            this.carbohydrate100gG = _data["carbohydrate100gG"];
            this.servingCarbohydrateG = _data["servingCarbohydrateG"];
            this.totalSugar100gG = _data["totalSugar100gG"];
            this.servingOfWhichTotalSugarG = _data["servingOfWhichTotalSugarG"];
            this.totalFat100gG = _data["totalFat100gG"];
            this.servingTotalFatG = _data["servingTotalFatG"];
            this.saturatedFat100gG = _data["saturatedFat100gG"];
            this.servingSaturatedFatG = _data["servingSaturatedFatG"];
            this.monounsaturatedFat100gG = _data["monounsaturatedFat100gG"];
            this.servingMonounsaturatedFatG = _data["servingMonounsaturatedFatG"];
            this.polyunsaturatedFat100gG = _data["polyunsaturatedFat100gG"];
            this.servingPolyunsaturatedFatG = _data["servingPolyunsaturatedFatG"];
            this.transFat100gG = _data["transFat100gG"];
            this.servingTransFatG = _data["servingTransFatG"];
            this.protein100gG = _data["protein100gG"];
            this.servingProteinG = _data["servingProteinG"];
            this.dietaryFibre100g = _data["dietaryFibre100g"];
            this.servingDietaryFibre = _data["servingDietaryFibre"];
            this.cholestrol100gMG = _data["cholestrol100gMG"];
            this.servingCholestrolMG = _data["servingCholestrolMG"];
            this.omega3FattyAcids100gMG = _data["omega3FattyAcids100gMG"];
            this.servingOmega3FattyAcidsMG = _data["servingOmega3FattyAcidsMG"];
            this.totalSodium100gMG = _data["totalSodium100gMG"];
            this.servingTotalSodiumMG = _data["servingTotalSodiumMG"];
        }
    }

    static fromJS(data: any): ProductExtendedDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductExtendedDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuCode"] = this.skuCode;
        data["primaryGTIN"] = this.primaryGTIN;
        data["manufacturerProductCode"] = this.manufacturerProductCode;
        data["packConfiguration"] = this.packConfiguration;
        data["productWidthMM"] = this.productWidthMM;
        data["productDepthMM"] = this.productDepthMM;
        data["productHeightMM"] = this.productHeightMM;
        data["productGrossWeightG"] = this.productGrossWeightG;
        data["brand"] = this.brand;
        data["subBrand"] = this.subBrand;
        data["productName"] = this.productName;
        data["productType"] = this.productType;
        data["productVariant"] = this.productVariant;
        data["needState"] = this.needState;
        data["modelNumber"] = this.modelNumber;
        data["packQuantity"] = this.packQuantity;
        data["unitOfSize"] = this.unitOfSize;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["productMaterials"] = this.productMaterials;
        data["colourName"] = this.colourName;
        data["siloMarketingDescription"] = this.siloMarketingDescription;
        data["siloKeywords"] = this.siloKeywords;
        data["siloShortDescription"] = this.siloShortDescription;
        data["siloFeaturesBenefits"] = this.siloFeaturesBenefits;
        data["videoLink"] = this.videoLink;
        data["packagingMaterial"] = this.packagingMaterial;
        data["recyclable"] = this.recyclable;
        data["whatsInTheBox"] = this.whatsInTheBox;
        data["countryOfOrigin"] = this.countryOfOrigin;
        data["usageInstructions"] = this.usageInstructions;
        data["storageInstructions"] = this.storageInstructions;
        data["shelfLifeSellBy"] = this.shelfLifeSellBy;
        data["serviceGuaranteeWarranty"] = this.serviceGuaranteeWarranty;
        data["generalWarnings"] = this.generalWarnings;
        data["ingredients"] = this.ingredients;
        data["allergenWarnings"] = this.allergenWarnings;
        data["commonAllergens"] = this.commonAllergens;
        data["organic"] = this.organic;
        data["vegan"] = this.vegan;
        data["vegetarian"] = this.vegetarian;
        data["glutenFree"] = this.glutenFree;
        data["freeRange"] = this.freeRange;
        data["otherClaims"] = this.otherClaims;
        data["halaal"] = this.halaal;
        data["kosher"] = this.kosher;
        data["otherEndorsements"] = this.otherEndorsements;
        data["alcoholPercentage"] = this.alcoholPercentage;
        data["servingSize"] = this.servingSize;
        data["servingSizeUOM"] = this.servingSizeUOM;
        data["energy100gKJ"] = this.energy100gKJ;
        data["servingEnergykJ"] = this.servingEnergykJ;
        data["carbohydrate100gG"] = this.carbohydrate100gG;
        data["servingCarbohydrateG"] = this.servingCarbohydrateG;
        data["totalSugar100gG"] = this.totalSugar100gG;
        data["servingOfWhichTotalSugarG"] = this.servingOfWhichTotalSugarG;
        data["totalFat100gG"] = this.totalFat100gG;
        data["servingTotalFatG"] = this.servingTotalFatG;
        data["saturatedFat100gG"] = this.saturatedFat100gG;
        data["servingSaturatedFatG"] = this.servingSaturatedFatG;
        data["monounsaturatedFat100gG"] = this.monounsaturatedFat100gG;
        data["servingMonounsaturatedFatG"] = this.servingMonounsaturatedFatG;
        data["polyunsaturatedFat100gG"] = this.polyunsaturatedFat100gG;
        data["servingPolyunsaturatedFatG"] = this.servingPolyunsaturatedFatG;
        data["transFat100gG"] = this.transFat100gG;
        data["servingTransFatG"] = this.servingTransFatG;
        data["protein100gG"] = this.protein100gG;
        data["servingProteinG"] = this.servingProteinG;
        data["dietaryFibre100g"] = this.dietaryFibre100g;
        data["servingDietaryFibre"] = this.servingDietaryFibre;
        data["cholestrol100gMG"] = this.cholestrol100gMG;
        data["servingCholestrolMG"] = this.servingCholestrolMG;
        data["omega3FattyAcids100gMG"] = this.omega3FattyAcids100gMG;
        data["servingOmega3FattyAcidsMG"] = this.servingOmega3FattyAcidsMG;
        data["totalSodium100gMG"] = this.totalSodium100gMG;
        data["servingTotalSodiumMG"] = this.servingTotalSodiumMG;
        return data;
    }
}

export interface IProductExtendedDetailsModel {
    id?: number;
    skuCode?: string | undefined;
    primaryGTIN?: string | undefined;
    manufacturerProductCode?: string | undefined;
    packConfiguration?: string | undefined;
    productWidthMM?: string | undefined;
    productDepthMM?: string | undefined;
    productHeightMM?: string | undefined;
    productGrossWeightG?: string | undefined;
    brand?: string | undefined;
    subBrand?: string | undefined;
    productName?: string | undefined;
    productType?: string | undefined;
    productVariant?: string | undefined;
    needState?: string | undefined;
    modelNumber?: string | undefined;
    packQuantity?: string | undefined;
    unitOfSize?: string | undefined;
    unitOfMeasure?: string | undefined;
    productMaterials?: string | undefined;
    colourName?: string | undefined;
    siloMarketingDescription?: string | undefined;
    siloKeywords?: string | undefined;
    siloShortDescription?: string | undefined;
    siloFeaturesBenefits?: string | undefined;
    videoLink?: string | undefined;
    packagingMaterial?: string | undefined;
    recyclable?: string | undefined;
    whatsInTheBox?: string | undefined;
    countryOfOrigin?: string | undefined;
    usageInstructions?: string | undefined;
    storageInstructions?: string | undefined;
    shelfLifeSellBy?: string | undefined;
    serviceGuaranteeWarranty?: string | undefined;
    generalWarnings?: string | undefined;
    ingredients?: string | undefined;
    allergenWarnings?: string | undefined;
    commonAllergens?: string | undefined;
    organic?: string | undefined;
    vegan?: string | undefined;
    vegetarian?: string | undefined;
    glutenFree?: string | undefined;
    freeRange?: string | undefined;
    otherClaims?: string | undefined;
    halaal?: string | undefined;
    kosher?: string | undefined;
    otherEndorsements?: string | undefined;
    alcoholPercentage?: string | undefined;
    servingSize?: string | undefined;
    servingSizeUOM?: string | undefined;
    energy100gKJ?: string | undefined;
    servingEnergykJ?: string | undefined;
    carbohydrate100gG?: string | undefined;
    servingCarbohydrateG?: string | undefined;
    totalSugar100gG?: string | undefined;
    servingOfWhichTotalSugarG?: string | undefined;
    totalFat100gG?: string | undefined;
    servingTotalFatG?: string | undefined;
    saturatedFat100gG?: string | undefined;
    servingSaturatedFatG?: string | undefined;
    monounsaturatedFat100gG?: string | undefined;
    servingMonounsaturatedFatG?: string | undefined;
    polyunsaturatedFat100gG?: string | undefined;
    servingPolyunsaturatedFatG?: string | undefined;
    transFat100gG?: string | undefined;
    servingTransFatG?: string | undefined;
    protein100gG?: string | undefined;
    servingProteinG?: string | undefined;
    dietaryFibre100g?: string | undefined;
    servingDietaryFibre?: string | undefined;
    cholestrol100gMG?: string | undefined;
    servingCholestrolMG?: string | undefined;
    omega3FattyAcids100gMG?: string | undefined;
    servingOmega3FattyAcidsMG?: string | undefined;
    totalSodium100gMG?: string | undefined;
    servingTotalSodiumMG?: string | undefined;
}

export class CategoryResult implements ICategoryResult {
    category?: string | undefined;
    categoryCount?: number;
    subCategories?: SubCategoryResult[] | undefined;

    constructor(data?: ICategoryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.categoryCount = _data["categoryCount"];
            if (Array.isArray(_data["subCategories"])) {
                this.subCategories = [] as any;
                for (let item of _data["subCategories"])
                    this.subCategories!.push(SubCategoryResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryResult {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["categoryCount"] = this.categoryCount;
        if (Array.isArray(this.subCategories)) {
            data["subCategories"] = [];
            for (let item of this.subCategories)
                data["subCategories"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoryResult {
    category?: string | undefined;
    categoryCount?: number;
    subCategories?: SubCategoryResult[] | undefined;
}

export class SubCategoryResult implements ISubCategoryResult {
    subCategory?: string | undefined;
    subCategoryCount?: number;
    subCategory3s?: SubCategory3Result[] | undefined;

    constructor(data?: ISubCategoryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subCategory = _data["subCategory"];
            this.subCategoryCount = _data["subCategoryCount"];
            if (Array.isArray(_data["subCategory3s"])) {
                this.subCategory3s = [] as any;
                for (let item of _data["subCategory3s"])
                    this.subCategory3s!.push(SubCategory3Result.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubCategoryResult {
        data = typeof data === 'object' ? data : {};
        let result = new SubCategoryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subCategory"] = this.subCategory;
        data["subCategoryCount"] = this.subCategoryCount;
        if (Array.isArray(this.subCategory3s)) {
            data["subCategory3s"] = [];
            for (let item of this.subCategory3s)
                data["subCategory3s"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubCategoryResult {
    subCategory?: string | undefined;
    subCategoryCount?: number;
    subCategory3s?: SubCategory3Result[] | undefined;
}

export class SubCategory3Result implements ISubCategory3Result {
    subCategory3?: string | undefined;
    subCategory3Count?: number;
    subCategory4s?: SubCategory4Result[] | undefined;

    constructor(data?: ISubCategory3Result) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subCategory3 = _data["subCategory3"];
            this.subCategory3Count = _data["subCategory3Count"];
            if (Array.isArray(_data["subCategory4s"])) {
                this.subCategory4s = [] as any;
                for (let item of _data["subCategory4s"])
                    this.subCategory4s!.push(SubCategory4Result.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubCategory3Result {
        data = typeof data === 'object' ? data : {};
        let result = new SubCategory3Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subCategory3"] = this.subCategory3;
        data["subCategory3Count"] = this.subCategory3Count;
        if (Array.isArray(this.subCategory4s)) {
            data["subCategory4s"] = [];
            for (let item of this.subCategory4s)
                data["subCategory4s"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubCategory3Result {
    subCategory3?: string | undefined;
    subCategory3Count?: number;
    subCategory4s?: SubCategory4Result[] | undefined;
}

export class SubCategory4Result implements ISubCategory4Result {
    subCategory4?: string | undefined;
    subCategory4Count?: number;

    constructor(data?: ISubCategory4Result) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subCategory4 = _data["subCategory4"];
            this.subCategory4Count = _data["subCategory4Count"];
        }
    }

    static fromJS(data: any): SubCategory4Result {
        data = typeof data === 'object' ? data : {};
        let result = new SubCategory4Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subCategory4"] = this.subCategory4;
        data["subCategory4Count"] = this.subCategory4Count;
        return data;
    }
}

export interface ISubCategory4Result {
    subCategory4?: string | undefined;
    subCategory4Count?: number;
}

export class BrandResult implements IBrandResult {
    name?: string | undefined;
    imageUrl?: string | undefined;

    constructor(data?: IBrandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): BrandResult {
        data = typeof data === 'object' ? data : {};
        let result = new BrandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface IBrandResult {
    name?: string | undefined;
    imageUrl?: string | undefined;
}

export class GetProductSearchQuery implements IGetProductSearchQuery {
    principleId?: number;
    pastelAccount?: string | undefined;
    pageNumber?: number;
    resultsPerPage?: number;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    descriptionFilter?: string | undefined;
    brandFilter?: string | undefined;
    categoryFilter?: string | undefined;
    subCategory1Filter?: string | undefined;
    subCategory2Filter?: string | undefined;
    subCategory3Filter?: string | undefined;
    featuredProductsOnly?: boolean;
    newProductsOnly?: boolean;
    inStockOnly?: boolean;

    constructor(data?: IGetProductSearchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.principleId = _data["principleId"];
            this.pastelAccount = _data["pastelAccount"];
            this.pageNumber = _data["pageNumber"];
            this.resultsPerPage = _data["resultsPerPage"];
            this.sortBy = _data["sortBy"];
            this.sortDirection = _data["sortDirection"];
            this.descriptionFilter = _data["descriptionFilter"];
            this.brandFilter = _data["brandFilter"];
            this.categoryFilter = _data["categoryFilter"];
            this.subCategory1Filter = _data["subCategory1Filter"];
            this.subCategory2Filter = _data["subCategory2Filter"];
            this.subCategory3Filter = _data["subCategory3Filter"];
            this.featuredProductsOnly = _data["featuredProductsOnly"];
            this.newProductsOnly = _data["newProductsOnly"];
            this.inStockOnly = _data["inStockOnly"];
        }
    }

    static fromJS(data: any): GetProductSearchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductSearchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["principleId"] = this.principleId;
        data["pastelAccount"] = this.pastelAccount;
        data["pageNumber"] = this.pageNumber;
        data["resultsPerPage"] = this.resultsPerPage;
        data["sortBy"] = this.sortBy;
        data["sortDirection"] = this.sortDirection;
        data["descriptionFilter"] = this.descriptionFilter;
        data["brandFilter"] = this.brandFilter;
        data["categoryFilter"] = this.categoryFilter;
        data["subCategory1Filter"] = this.subCategory1Filter;
        data["subCategory2Filter"] = this.subCategory2Filter;
        data["subCategory3Filter"] = this.subCategory3Filter;
        data["featuredProductsOnly"] = this.featuredProductsOnly;
        data["newProductsOnly"] = this.newProductsOnly;
        data["inStockOnly"] = this.inStockOnly;
        return data;
    }
}

export interface IGetProductSearchQuery {
    principleId?: number;
    pastelAccount?: string | undefined;
    pageNumber?: number;
    resultsPerPage?: number;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    descriptionFilter?: string | undefined;
    brandFilter?: string | undefined;
    categoryFilter?: string | undefined;
    subCategory1Filter?: string | undefined;
    subCategory2Filter?: string | undefined;
    subCategory3Filter?: string | undefined;
    featuredProductsOnly?: boolean;
    newProductsOnly?: boolean;
    inStockOnly?: boolean;
}

export class GetProductsQuery implements IGetProductsQuery {
    pageNumber?: number;
    resultsPerPage?: number;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    descriptionFilter?: string | undefined;
    brandFilter?: string | undefined;
    categoryFilter?: string | undefined;
    subCategory1Filter?: string | undefined;
    subCategory2Filter?: string | undefined;
    subCategory3Filter?: string | undefined;
    featuredProductsOnly?: boolean;
    newProductsOnly?: boolean;
    inStockOnly?: boolean;

    constructor(data?: IGetProductsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.resultsPerPage = _data["resultsPerPage"];
            this.sortBy = _data["sortBy"];
            this.sortDirection = _data["sortDirection"];
            this.descriptionFilter = _data["descriptionFilter"];
            this.brandFilter = _data["brandFilter"];
            this.categoryFilter = _data["categoryFilter"];
            this.subCategory1Filter = _data["subCategory1Filter"];
            this.subCategory2Filter = _data["subCategory2Filter"];
            this.subCategory3Filter = _data["subCategory3Filter"];
            this.featuredProductsOnly = _data["featuredProductsOnly"];
            this.newProductsOnly = _data["newProductsOnly"];
            this.inStockOnly = _data["inStockOnly"];
        }
    }

    static fromJS(data: any): GetProductsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["resultsPerPage"] = this.resultsPerPage;
        data["sortBy"] = this.sortBy;
        data["sortDirection"] = this.sortDirection;
        data["descriptionFilter"] = this.descriptionFilter;
        data["brandFilter"] = this.brandFilter;
        data["categoryFilter"] = this.categoryFilter;
        data["subCategory1Filter"] = this.subCategory1Filter;
        data["subCategory2Filter"] = this.subCategory2Filter;
        data["subCategory3Filter"] = this.subCategory3Filter;
        data["featuredProductsOnly"] = this.featuredProductsOnly;
        data["newProductsOnly"] = this.newProductsOnly;
        data["inStockOnly"] = this.inStockOnly;
        return data;
    }
}

export interface IGetProductsQuery {
    pageNumber?: number;
    resultsPerPage?: number;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    descriptionFilter?: string | undefined;
    brandFilter?: string | undefined;
    categoryFilter?: string | undefined;
    subCategory1Filter?: string | undefined;
    subCategory2Filter?: string | undefined;
    subCategory3Filter?: string | undefined;
    featuredProductsOnly?: boolean;
    newProductsOnly?: boolean;
    inStockOnly?: boolean;
}

export class GetProductBySkuQuery implements IGetProductBySkuQuery {
    skuCode?: string | undefined;

    constructor(data?: IGetProductBySkuQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuCode = _data["skuCode"];
        }
    }

    static fromJS(data: any): GetProductBySkuQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductBySkuQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuCode"] = this.skuCode;
        return data;
    }
}

export interface IGetProductBySkuQuery {
    skuCode?: string | undefined;
}

export class UploadProductImagesCommand implements IUploadProductImagesCommand {
    src?: string[] | undefined;
    skuCode?: string | undefined;

    constructor(data?: IUploadProductImagesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["src"])) {
                this.src = [] as any;
                for (let item of _data["src"])
                    this.src!.push(item);
            }
            this.skuCode = _data["skuCode"];
        }
    }

    static fromJS(data: any): UploadProductImagesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UploadProductImagesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.src)) {
            data["src"] = [];
            for (let item of this.src)
                data["src"].push(item);
        }
        data["skuCode"] = this.skuCode;
        return data;
    }
}

export interface IUploadProductImagesCommand {
    src?: string[] | undefined;
    skuCode?: string | undefined;
}

export class UpdateDescriptionCommand implements IUpdateDescriptionCommand {
    updatedDescription: string | undefined;
    skuCode?: string | undefined;

    constructor(data?: IUpdateDescriptionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedDescription = _data["updatedDescription"];
            this.skuCode = _data["skuCode"];
        }
    }

    static fromJS(data: any): UpdateDescriptionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDescriptionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedDescription"] = this.updatedDescription;
        data["skuCode"] = this.skuCode;
        return data;
    }
}

export interface IUpdateDescriptionCommand {
    updatedDescription: string | undefined;
    skuCode?: string | undefined;
}

export class AssignCoverImageCommand implements IAssignCoverImageCommand {
    mainImageIndex?: number;
    src?: string[] | undefined;
    skuCode?: string | undefined;

    constructor(data?: IAssignCoverImageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mainImageIndex = _data["mainImageIndex"];
            if (Array.isArray(_data["src"])) {
                this.src = [] as any;
                for (let item of _data["src"])
                    this.src!.push(item);
            }
            this.skuCode = _data["skuCode"];
        }
    }

    static fromJS(data: any): AssignCoverImageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignCoverImageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainImageIndex"] = this.mainImageIndex;
        if (Array.isArray(this.src)) {
            data["src"] = [];
            for (let item of this.src)
                data["src"].push(item);
        }
        data["skuCode"] = this.skuCode;
        return data;
    }
}

export interface IAssignCoverImageCommand {
    mainImageIndex?: number;
    src?: string[] | undefined;
    skuCode?: string | undefined;
}

export class RoleModel implements IRoleModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    enabled?: boolean;
    users?: UserModel[] | undefined;

    constructor(data?: IRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    enabled?: boolean;
    users?: UserModel[] | undefined;
}

export class UserModel implements IUserModel {
    id?: string;
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    email?: string | undefined;
    resetPasswordOnNextLogin?: boolean;
    isActiveDirectoryUser?: boolean;
    failedLoginAttempts?: number | undefined;
    lockoutExpiryDate?: Date | undefined;
    isActive?: boolean;
    signalRConnected?: boolean;
    createdBy?: string | undefined;
    createdDate?: Date;
    lastModifiedBy?: string | undefined;
    customerAccount?: string | undefined;
    lastModifiedDate?: Date | undefined;
    roles?: RoleModel[] | undefined;
    tenants?: TenantModel[] | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.email = _data["email"];
            this.resetPasswordOnNextLogin = _data["resetPasswordOnNextLogin"];
            this.isActiveDirectoryUser = _data["isActiveDirectoryUser"];
            this.failedLoginAttempts = _data["failedLoginAttempts"];
            this.lockoutExpiryDate = _data["lockoutExpiryDate"] ? new Date(_data["lockoutExpiryDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.signalRConnected = _data["signalRConnected"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.customerAccount = _data["customerAccount"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleModel.fromJS(item));
            }
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["email"] = this.email;
        data["resetPasswordOnNextLogin"] = this.resetPasswordOnNextLogin;
        data["isActiveDirectoryUser"] = this.isActiveDirectoryUser;
        data["failedLoginAttempts"] = this.failedLoginAttempts;
        data["lockoutExpiryDate"] = this.lockoutExpiryDate ? this.lockoutExpiryDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["signalRConnected"] = this.signalRConnected;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["customerAccount"] = this.customerAccount;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserModel {
    id?: string;
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    email?: string | undefined;
    resetPasswordOnNextLogin?: boolean;
    isActiveDirectoryUser?: boolean;
    failedLoginAttempts?: number | undefined;
    lockoutExpiryDate?: Date | undefined;
    isActive?: boolean;
    signalRConnected?: boolean;
    createdBy?: string | undefined;
    createdDate?: Date;
    lastModifiedBy?: string | undefined;
    customerAccount?: string | undefined;
    lastModifiedDate?: Date | undefined;
    roles?: RoleModel[] | undefined;
    tenants?: TenantModel[] | undefined;
}

export class TenantModel implements ITenantModel {
    id?: string;
    name?: string | undefined;
    enabled?: boolean;
    users?: UserModel[] | undefined;

    constructor(data?: ITenantModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITenantModel {
    id?: string;
    name?: string | undefined;
    enabled?: boolean;
    users?: UserModel[] | undefined;
}

export enum RoleEnum {
    Administrator = 100,
    UserManagement = 200,
    TenantManagement = 300,
}

export class IssuedTokenModel implements IIssuedTokenModel {
    token?: string | undefined;
    expiresIn?: number;

    constructor(data?: IIssuedTokenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.expiresIn = _data["expiresIn"];
        }
    }

    static fromJS(data: any): IssuedTokenModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssuedTokenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["expiresIn"] = this.expiresIn;
        return data;
    }
}

export interface IIssuedTokenModel {
    token?: string | undefined;
    expiresIn?: number;
}

export class AuthenticateUserCommand implements IAuthenticateUserCommand {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: IAuthenticateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthenticateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthenticateUserCommand {
    username?: string | undefined;
    password?: string | undefined;
}

export class AuthenticateUserViaEmailCommand implements IAuthenticateUserViaEmailCommand {
    emailAddress?: string | undefined;
    password?: string | undefined;

    constructor(data?: IAuthenticateUserViaEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthenticateUserViaEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateUserViaEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthenticateUserViaEmailCommand {
    emailAddress?: string | undefined;
    password?: string | undefined;
}

export class CreateUserCommand implements ICreateUserCommand {
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;
    isActiveDirectoryUser?: boolean;
    roles?: RoleEnum[] | undefined;
    tenants?: string[] | undefined;
    reports?: any[] | undefined;

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.password = _data["password"];
            this.email = _data["email"];
            this.isActiveDirectoryUser = _data["isActiveDirectoryUser"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(item);
            }
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["password"] = this.password;
        data["email"] = this.email;
        data["isActiveDirectoryUser"] = this.isActiveDirectoryUser;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item);
        }
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item);
        }
        return data;
    }
}

export interface ICreateUserCommand {
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;
    isActiveDirectoryUser?: boolean;
    roles?: RoleEnum[] | undefined;
    tenants?: string[] | undefined;
    reports?: any[] | undefined;
}

export class UpdateUserCommand implements IUpdateUserCommand {
    userId?: string;
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    email?: string | undefined;
    roles?: RoleEnum[] | undefined;
    tenants?: string[] | undefined;
    reports?: any[] | undefined;

    constructor(data?: IUpdateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.email = _data["email"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(item);
            }
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["email"] = this.email;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item);
        }
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserCommand {
    userId?: string;
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    email?: string | undefined;
    roles?: RoleEnum[] | undefined;
    tenants?: string[] | undefined;
    reports?: any[] | undefined;
}

export class ActiveDirectoryUserModel implements IActiveDirectoryUserModel {
    guid?: string | undefined;
    samAccountName?: string | undefined;
    userPrincipalName?: string | undefined;
    name?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    emailAddress?: string | undefined;
    isAccountLockedOut?: boolean;
    enabled?: boolean | undefined;

    constructor(data?: IActiveDirectoryUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.samAccountName = _data["samAccountName"];
            this.userPrincipalName = _data["userPrincipalName"];
            this.name = _data["name"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isAccountLockedOut = _data["isAccountLockedOut"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): ActiveDirectoryUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveDirectoryUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["samAccountName"] = this.samAccountName;
        data["userPrincipalName"] = this.userPrincipalName;
        data["name"] = this.name;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isAccountLockedOut"] = this.isAccountLockedOut;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IActiveDirectoryUserModel {
    guid?: string | undefined;
    samAccountName?: string | undefined;
    userPrincipalName?: string | undefined;
    name?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    emailAddress?: string | undefined;
    isAccountLockedOut?: boolean;
    enabled?: boolean | undefined;
}

export class ResetPasswordResponse implements IResetPasswordResponse {
    username?: string | undefined;

    constructor(data?: IResetPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): ResetPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export interface IResetPasswordResponse {
    username?: string | undefined;
}

export class ResetPasswordCommand implements IResetPasswordCommand {
    hash?: string | undefined;
    password?: string | undefined;

    constructor(data?: IResetPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hash = _data["hash"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ResetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hash"] = this.hash;
        data["password"] = this.password;
        return data;
    }
}

export interface IResetPasswordCommand {
    hash?: string | undefined;
    password?: string | undefined;
}

export class RequestPasswordResetResponse implements IRequestPasswordResetResponse {
    emailAddress?: string | undefined;

    constructor(data?: IRequestPasswordResetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): RequestPasswordResetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPasswordResetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IRequestPasswordResetResponse {
    emailAddress?: string | undefined;
}

export class RequestPasswordResetCommand implements IRequestPasswordResetCommand {
    username?: string | undefined;

    constructor(data?: IRequestPasswordResetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): RequestPasswordResetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPasswordResetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export interface IRequestPasswordResetCommand {
    username?: string | undefined;
}

export class PastelCustomerDetailModel implements IPastelCustomerDetailModel {
    pastelCustomerAccount?: string | undefined;
    cellphoneNumbers?: string[] | undefined;
    emailAddresses?: string[] | undefined;
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IPastelCustomerDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pastelCustomerAccount = _data["pastelCustomerAccount"];
            if (Array.isArray(_data["cellphoneNumbers"])) {
                this.cellphoneNumbers = [] as any;
                for (let item of _data["cellphoneNumbers"])
                    this.cellphoneNumbers!.push(item);
            }
            if (Array.isArray(_data["emailAddresses"])) {
                this.emailAddresses = [] as any;
                for (let item of _data["emailAddresses"])
                    this.emailAddresses!.push(item);
            }
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PastelCustomerDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new PastelCustomerDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pastelCustomerAccount"] = this.pastelCustomerAccount;
        if (Array.isArray(this.cellphoneNumbers)) {
            data["cellphoneNumbers"] = [];
            for (let item of this.cellphoneNumbers)
                data["cellphoneNumbers"].push(item);
        }
        if (Array.isArray(this.emailAddresses)) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item);
        }
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IPastelCustomerDetailModel {
    pastelCustomerAccount?: string | undefined;
    cellphoneNumbers?: string[] | undefined;
    emailAddresses?: string[] | undefined;
    success?: boolean;
    message?: string | undefined;
}

export class GetPastelCustomerByAccountQuery implements IGetPastelCustomerByAccountQuery {
    pastelCustomerAccount?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IGetPastelCustomerByAccountQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pastelCustomerAccount = _data["pastelCustomerAccount"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): GetPastelCustomerByAccountQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPastelCustomerByAccountQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pastelCustomerAccount"] = this.pastelCustomerAccount;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IGetPastelCustomerByAccountQuery {
    pastelCustomerAccount?: string | undefined;
    emailAddress?: string | undefined;
}

export class PastelCustomerModel implements IPastelCustomerModel {
    id?: number;
    name?: string | undefined;
    accountId?: string | undefined;
    grouping1?: string | undefined;
    grouping2?: string | undefined;
    grouping3?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    address4?: string | undefined;
    address5?: string | undefined;
    addressPC?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    pastelCustomerId?: number;
    contactName?: string | undefined;
    contactTelephone1?: string | undefined;
    contactTelephone2?: string | undefined;
    contactCellphone?: string | undefined;
    contactEmail?: string | undefined;
    taxNumber?: string | undefined;
    registrationNumber?: string | undefined;
    nominatedDeliveryDate?: string | undefined;
    nominatedOrderDate?: string | undefined;
    channelGroup?: string | undefined;
    channelSubGroup?: string | undefined;
    mainWarehouseCode?: string | undefined;
    warehouseId?: number;
    pricelistId?: number;
    pricelistName?: string | undefined;
    active?: boolean;
    vendorNumber?: string | undefined;
    repCode?: string | undefined;
    isLiquorCustomer?: boolean | undefined;
    stockingWarehouseCode?: string | undefined;

    constructor(data?: IPastelCustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.accountId = _data["accountId"];
            this.grouping1 = _data["grouping1"];
            this.grouping2 = _data["grouping2"];
            this.grouping3 = _data["grouping3"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.address4 = _data["address4"];
            this.address5 = _data["address5"];
            this.addressPC = _data["addressPC"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.pastelCustomerId = _data["pastelCustomerId"];
            this.contactName = _data["contactName"];
            this.contactTelephone1 = _data["contactTelephone1"];
            this.contactTelephone2 = _data["contactTelephone2"];
            this.contactCellphone = _data["contactCellphone"];
            this.contactEmail = _data["contactEmail"];
            this.taxNumber = _data["taxNumber"];
            this.registrationNumber = _data["registrationNumber"];
            this.nominatedDeliveryDate = _data["nominatedDeliveryDate"];
            this.nominatedOrderDate = _data["nominatedOrderDate"];
            this.channelGroup = _data["channelGroup"];
            this.channelSubGroup = _data["channelSubGroup"];
            this.mainWarehouseCode = _data["mainWarehouseCode"];
            this.warehouseId = _data["warehouseId"];
            this.pricelistId = _data["pricelistId"];
            this.pricelistName = _data["pricelistName"];
            this.active = _data["active"];
            this.vendorNumber = _data["vendorNumber"];
            this.repCode = _data["repCode"];
            this.isLiquorCustomer = _data["isLiquorCustomer"];
            this.stockingWarehouseCode = _data["stockingWarehouseCode"];
        }
    }

    static fromJS(data: any): PastelCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new PastelCustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["accountId"] = this.accountId;
        data["grouping1"] = this.grouping1;
        data["grouping2"] = this.grouping2;
        data["grouping3"] = this.grouping3;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["address4"] = this.address4;
        data["address5"] = this.address5;
        data["addressPC"] = this.addressPC;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["pastelCustomerId"] = this.pastelCustomerId;
        data["contactName"] = this.contactName;
        data["contactTelephone1"] = this.contactTelephone1;
        data["contactTelephone2"] = this.contactTelephone2;
        data["contactCellphone"] = this.contactCellphone;
        data["contactEmail"] = this.contactEmail;
        data["taxNumber"] = this.taxNumber;
        data["registrationNumber"] = this.registrationNumber;
        data["nominatedDeliveryDate"] = this.nominatedDeliveryDate;
        data["nominatedOrderDate"] = this.nominatedOrderDate;
        data["channelGroup"] = this.channelGroup;
        data["channelSubGroup"] = this.channelSubGroup;
        data["mainWarehouseCode"] = this.mainWarehouseCode;
        data["warehouseId"] = this.warehouseId;
        data["pricelistId"] = this.pricelistId;
        data["pricelistName"] = this.pricelistName;
        data["active"] = this.active;
        data["vendorNumber"] = this.vendorNumber;
        data["repCode"] = this.repCode;
        data["isLiquorCustomer"] = this.isLiquorCustomer;
        data["stockingWarehouseCode"] = this.stockingWarehouseCode;
        return data;
    }
}

export interface IPastelCustomerModel {
    id?: number;
    name?: string | undefined;
    accountId?: string | undefined;
    grouping1?: string | undefined;
    grouping2?: string | undefined;
    grouping3?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    address4?: string | undefined;
    address5?: string | undefined;
    addressPC?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    pastelCustomerId?: number;
    contactName?: string | undefined;
    contactTelephone1?: string | undefined;
    contactTelephone2?: string | undefined;
    contactCellphone?: string | undefined;
    contactEmail?: string | undefined;
    taxNumber?: string | undefined;
    registrationNumber?: string | undefined;
    nominatedDeliveryDate?: string | undefined;
    nominatedOrderDate?: string | undefined;
    channelGroup?: string | undefined;
    channelSubGroup?: string | undefined;
    mainWarehouseCode?: string | undefined;
    warehouseId?: number;
    pricelistId?: number;
    pricelistName?: string | undefined;
    active?: boolean;
    vendorNumber?: string | undefined;
    repCode?: string | undefined;
    isLiquorCustomer?: boolean | undefined;
    stockingWarehouseCode?: string | undefined;
}

export class PreRegisterResultModel implements IPreRegisterResultModel {
    success?: boolean;
    message?: string | undefined;
    otpKey?: string | undefined;

    constructor(data?: IPreRegisterResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.otpKey = _data["otpKey"];
        }
    }

    static fromJS(data: any): PreRegisterResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new PreRegisterResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["otpKey"] = this.otpKey;
        return data;
    }
}

export interface IPreRegisterResultModel {
    success?: boolean;
    message?: string | undefined;
    otpKey?: string | undefined;
}

export class PreRegisterUserCommand implements IPreRegisterUserCommand {
    sendOtpViaEmail?: boolean;
    sendOtpViaSms?: boolean;
    otpSMSNumber?: string | undefined;
    otpEmailAddress?: string | undefined;
    pastelCustomerAccount?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IPreRegisterUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sendOtpViaEmail = _data["sendOtpViaEmail"];
            this.sendOtpViaSms = _data["sendOtpViaSms"];
            this.otpSMSNumber = _data["otpSMSNumber"];
            this.otpEmailAddress = _data["otpEmailAddress"];
            this.pastelCustomerAccount = _data["pastelCustomerAccount"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): PreRegisterUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PreRegisterUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendOtpViaEmail"] = this.sendOtpViaEmail;
        data["sendOtpViaSms"] = this.sendOtpViaSms;
        data["otpSMSNumber"] = this.otpSMSNumber;
        data["otpEmailAddress"] = this.otpEmailAddress;
        data["pastelCustomerAccount"] = this.pastelCustomerAccount;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IPreRegisterUserCommand {
    sendOtpViaEmail?: boolean;
    sendOtpViaSms?: boolean;
    otpSMSNumber?: string | undefined;
    otpEmailAddress?: string | undefined;
    pastelCustomerAccount?: string | undefined;
    emailAddress?: string | undefined;
}

export class RegisterExternalUserCommand implements IRegisterExternalUserCommand {
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;
    isActiveDirectoryUser?: boolean;
    roles?: RoleEnum[] | undefined;
    tenants?: string[] | undefined;
    reports?: any[] | undefined;
    otpKey?: string | undefined;
    otpPin?: number;
    customerAccount?: string | undefined;

    constructor(data?: IRegisterExternalUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.password = _data["password"];
            this.email = _data["email"];
            this.isActiveDirectoryUser = _data["isActiveDirectoryUser"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(item);
            }
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(item);
            }
            this.otpKey = _data["otpKey"];
            this.otpPin = _data["otpPin"];
            this.customerAccount = _data["customerAccount"];
        }
    }

    static fromJS(data: any): RegisterExternalUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterExternalUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["password"] = this.password;
        data["email"] = this.email;
        data["isActiveDirectoryUser"] = this.isActiveDirectoryUser;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item);
        }
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item);
        }
        data["otpKey"] = this.otpKey;
        data["otpPin"] = this.otpPin;
        data["customerAccount"] = this.customerAccount;
        return data;
    }
}

export interface IRegisterExternalUserCommand {
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;
    isActiveDirectoryUser?: boolean;
    roles?: RoleEnum[] | undefined;
    tenants?: string[] | undefined;
    reports?: any[] | undefined;
    otpKey?: string | undefined;
    otpPin?: number;
    customerAccount?: string | undefined;
}

export class WishlistModel implements IWishlistModel {
    id?: number;
    userId?: string;
    orderReference?: string | undefined;
    createdDate?: Date;
    wishlistItems?: WishlistItemModel[] | undefined;
    totalPriceExcl?: number;
    totalPriceIncl?: number;
    discount?: number;
    numberOfItems?: number;

    constructor(data?: IWishlistModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.orderReference = _data["orderReference"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["wishlistItems"])) {
                this.wishlistItems = [] as any;
                for (let item of _data["wishlistItems"])
                    this.wishlistItems!.push(WishlistItemModel.fromJS(item));
            }
            this.totalPriceExcl = _data["totalPriceExcl"];
            this.totalPriceIncl = _data["totalPriceIncl"];
            this.discount = _data["discount"];
            this.numberOfItems = _data["numberOfItems"];
        }
    }

    static fromJS(data: any): WishlistModel {
        data = typeof data === 'object' ? data : {};
        let result = new WishlistModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["orderReference"] = this.orderReference;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        if (Array.isArray(this.wishlistItems)) {
            data["wishlistItems"] = [];
            for (let item of this.wishlistItems)
                data["wishlistItems"].push(item.toJSON());
        }
        data["totalPriceExcl"] = this.totalPriceExcl;
        data["totalPriceIncl"] = this.totalPriceIncl;
        data["discount"] = this.discount;
        data["numberOfItems"] = this.numberOfItems;
        return data;
    }
}

export interface IWishlistModel {
    id?: number;
    userId?: string;
    orderReference?: string | undefined;
    createdDate?: Date;
    wishlistItems?: WishlistItemModel[] | undefined;
    totalPriceExcl?: number;
    totalPriceIncl?: number;
    discount?: number;
    numberOfItems?: number;
}

export class WishlistItemModel implements IWishlistItemModel {
    id?: number;
    wishlistId?: number;
    productId?: string | undefined;
    productDescription?: string | undefined;
    quantity?: number;
    listPriceExcl?: number;
    listPriceincl?: number;
    unitPriceExcl?: number;
    totalPriceExcl?: number;
    totalPriceIncl?: number;
    dealReference?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    brand?: string | undefined;
    assignedDiscount?: number;
    dealDescription?: string | undefined;
    stockOnHand?: number;
    packSize?: string | undefined;
    capacity?: string | undefined;
    discountPercentage?: number;
    discountPriceExcl?: number | undefined;
    discountPriceIncl?: number | undefined;
    minOrderQuantityDiscount?: number;
    isNewProduct?: boolean | undefined;
    imageUrl?: string | undefined;
    rtCategory?: string | undefined;
    stockingWarehouseCode?: string | undefined;

    constructor(data?: IWishlistItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wishlistId = _data["wishlistId"];
            this.productId = _data["productId"];
            this.productDescription = _data["productDescription"];
            this.quantity = _data["quantity"];
            this.listPriceExcl = _data["listPriceExcl"];
            this.listPriceincl = _data["listPriceincl"];
            this.unitPriceExcl = _data["unitPriceExcl"];
            this.totalPriceExcl = _data["totalPriceExcl"];
            this.totalPriceIncl = _data["totalPriceIncl"];
            this.dealReference = _data["dealReference"];
            this.category = _data["category"];
            this.subCategory = _data["subCategory"];
            this.brand = _data["brand"];
            this.assignedDiscount = _data["assignedDiscount"];
            this.dealDescription = _data["dealDescription"];
            this.stockOnHand = _data["stockOnHand"];
            this.packSize = _data["packSize"];
            this.capacity = _data["capacity"];
            this.discountPercentage = _data["discountPercentage"];
            this.discountPriceExcl = _data["discountPriceExcl"];
            this.discountPriceIncl = _data["discountPriceIncl"];
            this.minOrderQuantityDiscount = _data["minOrderQuantityDiscount"];
            this.isNewProduct = _data["isNewProduct"];
            this.imageUrl = _data["imageUrl"];
            this.rtCategory = _data["rtCategory"];
            this.stockingWarehouseCode = _data["stockingWarehouseCode"];
        }
    }

    static fromJS(data: any): WishlistItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new WishlistItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wishlistId"] = this.wishlistId;
        data["productId"] = this.productId;
        data["productDescription"] = this.productDescription;
        data["quantity"] = this.quantity;
        data["listPriceExcl"] = this.listPriceExcl;
        data["listPriceincl"] = this.listPriceincl;
        data["unitPriceExcl"] = this.unitPriceExcl;
        data["totalPriceExcl"] = this.totalPriceExcl;
        data["totalPriceIncl"] = this.totalPriceIncl;
        data["dealReference"] = this.dealReference;
        data["category"] = this.category;
        data["subCategory"] = this.subCategory;
        data["brand"] = this.brand;
        data["assignedDiscount"] = this.assignedDiscount;
        data["dealDescription"] = this.dealDescription;
        data["stockOnHand"] = this.stockOnHand;
        data["packSize"] = this.packSize;
        data["capacity"] = this.capacity;
        data["discountPercentage"] = this.discountPercentage;
        data["discountPriceExcl"] = this.discountPriceExcl;
        data["discountPriceIncl"] = this.discountPriceIncl;
        data["minOrderQuantityDiscount"] = this.minOrderQuantityDiscount;
        data["isNewProduct"] = this.isNewProduct;
        data["imageUrl"] = this.imageUrl;
        data["rtCategory"] = this.rtCategory;
        data["stockingWarehouseCode"] = this.stockingWarehouseCode;
        return data;
    }
}

export interface IWishlistItemModel {
    id?: number;
    wishlistId?: number;
    productId?: string | undefined;
    productDescription?: string | undefined;
    quantity?: number;
    listPriceExcl?: number;
    listPriceincl?: number;
    unitPriceExcl?: number;
    totalPriceExcl?: number;
    totalPriceIncl?: number;
    dealReference?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    brand?: string | undefined;
    assignedDiscount?: number;
    dealDescription?: string | undefined;
    stockOnHand?: number;
    packSize?: string | undefined;
    capacity?: string | undefined;
    discountPercentage?: number;
    discountPriceExcl?: number | undefined;
    discountPriceIncl?: number | undefined;
    minOrderQuantityDiscount?: number;
    isNewProduct?: boolean | undefined;
    imageUrl?: string | undefined;
    rtCategory?: string | undefined;
    stockingWarehouseCode?: string | undefined;
}

export class AddItemToWishlistCommand implements IAddItemToWishlistCommand {
    skuCode?: string | undefined;
    quantity?: number;
    dealReference?: string | undefined;

    constructor(data?: IAddItemToWishlistCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuCode = _data["skuCode"];
            this.quantity = _data["quantity"];
            this.dealReference = _data["dealReference"];
        }
    }

    static fromJS(data: any): AddItemToWishlistCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddItemToWishlistCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuCode"] = this.skuCode;
        data["quantity"] = this.quantity;
        data["dealReference"] = this.dealReference;
        return data;
    }
}

export interface IAddItemToWishlistCommand {
    skuCode?: string | undefined;
    quantity?: number;
    dealReference?: string | undefined;
}

export class RemoveItemFromWishlistCommand implements IRemoveItemFromWishlistCommand {
    skuCode?: string | undefined;

    constructor(data?: IRemoveItemFromWishlistCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuCode = _data["skuCode"];
        }
    }

    static fromJS(data: any): RemoveItemFromWishlistCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveItemFromWishlistCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuCode"] = this.skuCode;
        return data;
    }
}

export interface IRemoveItemFromWishlistCommand {
    skuCode?: string | undefined;
}

export class ClearWishlistCommand implements IClearWishlistCommand {

    constructor(data?: IClearWishlistCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ClearWishlistCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClearWishlistCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IClearWishlistCommand {
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
